import "whatwg-fetch";
import 'url-search-params-polyfill';

import React, {useEffect} from "react";
import AwardBadge from '../components/AwardBadge.js';
import BestsellerBadge from './BestsellerBadge.js';
import { useExtraData} from "./DataContext.js";

const BookBadges = () => {

    let { _source } = useExtraData();
    
    const r = _source;

    let debutAuthor = false;
    let num = 0;

    if (r.isbookpack == 1) num++;
    if (r.is_recommended_read === true) num++;
    if (r.is_book_of_the_week === true) num++;
    if (r.downloadable_resource_type) num++;
    if (r.advisory === true) num++;
    num += ((r.awards_won ? r.awards_won.length : 0) + (r.awards_short ? r.awards_short.length : 0));
    if (r.is_bestseller === true) num++;
    if (r.keywords && r.keywords.some(k => k.value === '1324')) {
        debutAuthor = true;
        num++;
    }
    const usesmall = num > 2;

    useEffect(() => {}, []);

    return (
        <div className={"imageBadgeContainer"+(usesmall ? " flexBadges" : "")}>

            {r.is_recommended_read === true && <span><img className="bookBadge recommendedRead" src={"/assets/img/" + (usesmall ? "recreadssmall.png" : "recommendedReadsBadge.png")} alt="Recommended read" title="Recommended read" /></span>}
            {r.is_book_of_the_week === true && <span><img className="bookBadge bookOfTheWeek" src={"/assets/img/" + (usesmall ? "bookoftheweeksmall.png" : "bookbold.png")} alt="Book of the week" title="Book of the week" /></span>}
            {r.isbookpack == 1 && <span><img className="bookBadge bookPack" src={"/assets/img/bookpackbadge.png"} alt="Book pack" /></span>}
            {r.downloadable_resource_type && <span><img className="bookBadge downloadableResources" height="38px" width="231px" src={"/assets/img/" + (usesmall ? "resourcesmail.png" : "resourcesBadge.png")} alt="Downloadable resource available" title="Downloadable resources available" /></span>}
            {r.advisory === true && usesmall && <span><img className="bookBadge contentAdvisory" title={r.advisory_note} src="/assets/img/contentwarning.png" /></span>}
            {r.advisory === true && !usesmall && <span><img className="bookBadge contentAdvisory" title={r.advisory_note} src="/assets/img/contentwarningwords.png" /></span>}
            {r.awards_won && r.awards_won.map((a, i) =>
                <AwardBadge key={i} award={a} placement="Winner" small={usesmall}  />
            )}
            {r.awards_short && r.awards_short.filter(a => r.awards_won === null || !r.awards_won.includes(a)).map((a, i) => 
                <AwardBadge key={i} award={a} placement="Shortlisted" small={usesmall} />
            )}
            {r.is_bestseller === true && <BestsellerBadge productId={r.product_id} small={usesmall} /> }
            {debutAuthor && <p className={'debutAuthorTitle carouselBadgeHeader productBadge'+(usesmall ? ' searchBadge' : '')} title='Debut author/illustrator'>
                <i className='fas fa-star-exclamation'></i>{(!usesmall ? <span><strong>Debut</strong></span> : "")}
            </p>}
        </div>
    );
}

export default BookBadges;